/*eslint-disable*/
import api from '../'

class divideUnstressedVowelsGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/divideUnstressedVowels/items', { params }).then(response => response.data.items);
    }
}

export default divideUnstressedVowelsGameItems;
